import Util from "../utils/util.js";
import Swiper from 'swiper';
import { Navigation, Controller, Thumbs } from 'swiper/modules';

class WebcamCarousel {

    constructor() {

        this.initWebcamCarousel();

    }

    initWebcamCarousel() {

		let widget = Util.$('.js-webcam-carousel-widget');

        if(widget.length > 0){

            widget.forEach(el => {

				let title = Util.$('.js-webcam-carousel-widget__title', el)[0];

				let webcamList = Util.$('.js-webcam', el);
				let thumbList = Util.$('.js-webcam-thumb', el);
				let thumbImgList = Util.$('.js-webcam-thumb__img', el);

                let mainSlider = Util.$('.js-webcam-carousel-widget__main-slider', el)[0];
				let controlSlider = Util.$('.js-webcam-carousel-widget__control-slider', el)[0];

				let ctrlPrevMainSlider = Util.$('.js-ctrl-prev-main-slider', el)[0];
				let ctrlNextMainSlider = Util.$('.js-ctrl-next-main-slider', el)[0];

				let ctrlPrevControlSlider = Util.$('.js-ctrl-prev-control-slider', el)[0];
				let ctrlNextControlSlider = Util.$('.js-ctrl-next-control-slider', el)[0];

				let controlSliderSwiper = new Swiper(controlSlider, {
					modules: [Navigation],
					loop: true,
					spaceBetween: 20,
					slidesPerView: 2,
					breakpoints: {
						768: {
							spaceBetween: 20,
							slidesPerView: 3,
						},
						1024: {
							spaceBetween: 30,
							slidesPerView: 4,
						}
					},
					navigation: {
						prevEl: ctrlPrevControlSlider,
						nextEl: ctrlNextControlSlider,
					},
				});

				let mainSliderSwiper = new Swiper(mainSlider, {
					modules: [Navigation, Controller, Thumbs],
					loop: true,
					spaceBetween: 30,
					navigation: {
						prevEl: ctrlPrevMainSlider,
						nextEl: ctrlNextMainSlider,
					},
					thumbs: {
						swiper: controlSliderSwiper
					}
				});

				mainSliderSwiper.on('slideChange', function() {
					var index = mainSliderSwiper.realIndex;
					title.innerHTML = webcamList[index].dataset.title;
				});

				window.addEventListener("load", function() {

					for (let i = 0; i < thumbList.length; i++) {
						let thumb = thumbList[i];
						thumb.addEventListener('keyup', function(e) {
							e.preventDefault();
							if (e.keyCode === 13) {
								mainSliderSwiper.slideTo(i, 0, false);
							}
						});
					}

					let attempts = 3;
					let id = setInterval(() => {

						if (attempts-- <= 0) {
							clearInterval(id);
							return;
						}

						console.log('Syncing webcam carousel thumbnails...');

						for (let i = 0; i < webcamList.length; i++) {

							let webcam = webcamList[i];
							let container = Util.$('div', webcam)[0];
							let src = null;

							if (container.className == 'webcam__hdrelay') {

								let hdrDiv = Util.$('div', container)[0];
								let hdrSr = hdrDiv.shadowRoot;

								if (hdrSr) {
									
									let hdrSrDiv = hdrSr.firstChild;

									if (hdrSrDiv) {
										container = Util.$('.hdrelay-default-clicktoplay, .hdrelay-jpg-video-img', hdrSrDiv)[0];
									}
									
								}
							}

							let img = Util.$('img', container);

							if (img.length > 0) {

								src = img[0].src;

							} else {

								let imgDiv = Util.$('.image', container);

								if (imgDiv.length > 0) {
									src = imgDiv[0].style.backgroundImage
										.replace('url("', '')
										.replace('")', '');
								}

							}

							if (src != null) {

								let thumbImg = thumbImgList[i];
								thumbImg.style.backgroundImage = `url('${src}')`;

							}

						} // End for.

						console.log('Webcam carousel thumbnails synched')

					}, 2000);

				});

            });

        }
        
    }

}
export default WebcamCarousel;